import ButtonComponent from "../../../components/common/button/Button"
import Modal from "../../../components/common/modal/Modal";
import './DeleteUserModal.css';

export const DeleteUserModal = ({ openDeleteConfirmationModalData, handleCloseDeleteModal, handleDeleteConfirmation }) => {
    
    const onCloseDeleteModal = () => {
        handleCloseDeleteModal();
    }
    const onClickCancel = () => {
        handleCloseDeleteModal();
    }
    const onClickYes = () => {
        handleDeleteConfirmation();
    }
    return (
        <div>
            <Modal
                className="DeleteUserModal_cls"
                open={openDeleteConfirmationModalData}
                handleClose={onCloseDeleteModal}
                title={"Remove User Access"}
                fullWidth={true}
                maxWidth={"md"}
                action={
                    <DeleteUserModalFooter
                        onClickCancel={onClickCancel}
                        onClickYes={onClickYes}
                    />
                }
                content={
                    <DeleteUserModalContent />
                }
            />
        </div>
    )
}

const DeleteUserModalFooter = ({ onClickCancel, onClickYes }) => {
    return (
        <div className='btn-wrapper' style={{ display: 'flex', gap: 10 }}>
            <ButtonComponent
                label="No"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                label="Yes"
                type="secondary"
                maxWidth="80px"
                onClick={onClickYes}
            />
        </div>
    );
}
const DeleteUserModalContent = () => {
    return (
        <div className='finalLTupdatedfooter-btn-wrapper'>
            <p>Do you want to remove user access?</p>
        </div>
    );
}